import { http } from '../../helpers';
import { fetchLabs } from './fetchLabs';

export function updateLab(payload) {
    return (dispatch) => {
        const relativeUrl = `/case-api/labs/${payload.id}`;
        http.put(relativeUrl, payload)
            .then((res) => {
                if (res.status === 200) {
                    dispatch(fetchLabs());
                }
            })
            .catch((error) => {
                console.warn(error);
            });
    };
}
